import { FormFieldConfig } from '../../types/mold';
import FormField from '../shared/FormField';

import { isFieldRequired } from '../../utils/formUtils';

interface FormFieldWrapperProps {
  config: FormFieldConfig;
  value: any;
  onChange: (value: any) => void;
  displayStyle?: 'default' | 'inline' | 'inline-expanded';
  isEditing?: boolean;
  disabled?: boolean;
  hasError?: boolean;
  isRequired?: boolean;
  details?: any; // Pass current form details for required function
}

const FormFieldWrapper: React.FC<FormFieldWrapperProps> = ({
  config,
  value,
  onChange,
  displayStyle = 'default',
  isEditing = true,
  disabled = false,
  hasError = false,
  isRequired = false,
  details = {},
}) => {
  // Ensure computedConfig.dependencyFields is a string[] to satisfy FormField prop types
  const { computedConfig, ...restConfig } = config as any;
  const normalizedComputedConfig = computedConfig
    ? {
        ...computedConfig,
        dependencyFields: Array.isArray(computedConfig.dependencyFields)
          ? computedConfig.dependencyFields.map((d: any) => String(d))
          : [],
      }
    : undefined;
  // Generate a unique id for the field
  const fieldId = `form-field-${String(config.key).replace(/\./g, '-')}`;
  // Use isFieldRequired utility, allow override by isRequired prop
  const considerFieldRequired = isFieldRequired(config, details)

  if (['inline', 'inline-expanded'].includes(displayStyle)) {
    const textColor = hasError ? 'text-red-500' : 'text-gray-500';
    const isExpanded = displayStyle === 'inline-expanded';
    const gridClasses = isExpanded ? 'grid-cols-3' : 'grid-cols-2';
    const labelWidth = isExpanded ? 'col-span-2' : '';
    return (
      <div className={`w-full grid ${gridClasses} items-center space-x-2`}>
        <label htmlFor={fieldId} className={`text-sm sm:text-base font-medium ${textColor}`}>{config.label}</label>
        <div className={`flex items-center ${labelWidth}`}>
          <FormField
            {...restConfig}
            computedConfig={normalizedComputedConfig}
            required={considerFieldRequired}
            hasError={hasError}
            formType={config.type}
            key={String(config.key)}
            label={config.label}
            value={value}
            onChange={onChange}
            testIdIdentifier={String(config.key)}
            previewMode={!isEditing}
            disabled={disabled}
            onSaveCustomValue={config.onSaveCustomValue}
            id={fieldId}
          />
        </div>
      </div>
    );
  }
  return (
    <div className="grid gap-2">
      <label htmlFor={fieldId} className="text-sm font-medium text-gray-700">
        {config.label}<span className="text-sm text-red-800">{considerFieldRequired ? '*' : ''}</span>
      </label>
      <FormField
        {...restConfig}
        required={considerFieldRequired}
        computedConfig={normalizedComputedConfig}
        hasError={hasError}
        formType={config.type}
        key={String(config.key)}
        label={config.label}
        value={value}
        onChange={onChange}
        testIdIdentifier={String(config.key)}
        previewMode={!isEditing}
        disabled={disabled}
        onSaveCustomValue={config.onSaveCustomValue}
        id={fieldId}
      />
    </div>
  );
};

export default FormFieldWrapper;